module.exports = __webpack_public_path__ + "static/media/playboy.09924341.mp4";